// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style-module_wrapper_iCUQeOg5bfh19x3L4rQF {
  margin-bottom: 2rem;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/components/MessageError/style.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,WAAA;AACF","sourcesContent":[".wrapper {\n  margin-bottom: 2rem;\n  width: 100%\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `style-module_wrapper_iCUQeOg5bfh19x3L4rQF`
};
export default ___CSS_LOADER_EXPORT___;
